import ReactDOM from 'react-dom/client';
import App from './App';

const bootstrap = () => {
  const root = document.getElementById('root');
  if (!root) {
    throw new Error('Root element #root was not found.');
  }

  ReactDOM.createRoot(root).render(<App />);
};

bootstrap();
